import { createAction, props } from '@ngrx/store';

import type { ILocalizationSettings } from '../../models/responses';

export const loadLocalizationSettings = createAction('[Setting] load local settings');
export const loadLocalizationSettingsSuccess = createAction(
  '[Setting] load local settings success',
  props<{ settings: ILocalizationSettings }>(),
);
export const loadLocalizationSettingsFail = createAction('[Setting] load local settings fail');
